import { InvoiceItemArray } from './invoice.item';
import { SortItem } from '../ss-api/responses/member.dashboard.license.response';
import { ISortable } from '../../../app/helpers/sort';
import { InvoicePaymentTransactionItemArray } from './invoice.payment.transaction.item';

export enum BillingCycleTypes {
    OneTime = 0,
    Monthly = 1,
    Annually = 2,
    NotDefined = 99
}

export enum PaymentMethodTypes {
    CreditCard = 0,
    CashOrCheck = 1,
    BankTransfer = 2
}

export interface IInvoice {

    MemberID: number;
    InvoiceID: number;

    // leave a string becuase an invoicenumber can be oct-12345 or x-12455
    InvoiceNumber: string;

    DateTimeCreated: Date;
    DateTimePaid: Date;
    LastCaptureAttempt: Date;
    CreditCardLast4: string;
    PaydByCheck: boolean;
    Description: string;
    SubTotal: number;
    Total: number;
    Credit: number;
    CustomTaxAmount: number;
    Status: string;
    PaymentMethod: string;
    LicenseID: number;
    LicenseKey: string;
    GraceDay: number;
    TaxServiceID: string;

    IsUpgradeInvoice: boolean;

    Items: InvoiceItemArray;

}

export class Invoice implements IInvoice {

    MemberID: number;
    FirstName: string;
    LastName: string;
    Company: string;
    Email: string;
    InvoiceID: number;

    // leave a string becuase an invoicenumber can be oct-12345 or x-12455
    InvoiceNumber: string;

    Description: string;

    DateTimeCreated: Date;
    DateTimePaid: Date;
    LastCaptureAttempt: Date;
    DueDate: Date;
    CreditCardLast4: string;
    PaydByCheck: boolean;

    SubTotal: number;
    Total: number;
    Credit: number;
    Status: string;
    PaymentMethod: string;
    LicenseID: number;
    LicenseKey: string;
    GraceDay: number;
    TaxServiceID: string;

    TotalDue: number;
    CustomTaxAmount: number;
    CustomTaxRate: number;
    CustomTaxRateDisplay: string;
    TotalPaid: number;
    TotalRefunded: number;

    IsUpgradeInvoice: boolean;

    Items: InvoiceItemArray;
    PaymentTransactions: InvoicePaymentTransactionItemArray;

    public static FixDates(item: Invoice) {
        item.DateTimeCreated = new Date(item.DateTimeCreated);
        item.DateTimePaid = new Date(item.DateTimePaid);
        item.LastCaptureAttempt = new Date(item.LastCaptureAttempt);
        item.DueDate = new Date(item.DueDate);

        if (item.PaymentTransactions != undefined)
            InvoicePaymentTransactionItemArray.FixDates(item.PaymentTransactions);
    }

}

export class InvoiceArray extends Array<Invoice> implements ISortable {

    public LastSort: SortItem;

    constructor(...items: Invoice[]) {
        super(...items);
        Object.setPrototypeOf(this, InvoiceArray.prototype);
        this.LastSort = new SortItem();

    }

    public static FixDates(item: InvoiceArray) {
        item.forEach(x => Invoice.FixDates(x));
    }

}
